// extracted by mini-css-extract-plugin
export default {"root":"QuizProgressBarV3_root-hwz","segment":"QuizProgressBarV3_segment-Bx7","fill":"QuizProgressBarV3_fill-yjL"};